<!-- Redirect stub — forgot-password form now lives inline in LoginComponent -->
<div></div>
